<template>
  <div class='basicinfomation'>
    <div class="top">
      基本信息
    </div>
    <div class="body">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        class="userInfo"
      >
        <el-form-item label="账号">
          <el-input
            v-model="form.account"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="工号">
          <el-input
            v-model="form.usercode"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="form.username"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-input
            v-model="form.gender"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-input
            v-model="form.usertype"
            disabled
          ></el-input>
        </el-form-item>

      </el-form>
      <div class="avatar">
        <el-upload
          :action="action"
          :data="imgData"
          :headers="headers"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <el-avatar
            :size="200"
            :src="avatarsrc"
          ></el-avatar>
        </el-upload>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'
import base from '../../api/base'

export default {
  data () {
    return {
      form: {
        account: '',
        usercode: '',
        username: '',
        gender: '',
        usertype: '',
      },
      avatarsrc: '',
      action: base.qa + '/User/UploadImg',
      imgData: {
        userid: '',
      },
      userid: '',
      headers: {
        Authorization: 'Bearer ' + window.localStorage.getItem('token')
      }

    }
  },
  created () {
    this.imgData.userid = JSON.parse(window.sessionStorage.getItem('userinfo')).userid
    this.userid = JSON.parse(window.sessionStorage.getItem('userinfo')).userid
    this.GetUserInfo()
  },
  mounted () {

  },
  methods: {
    async GetUserInfo () {
      const res = await Api.userinfo.GetUserInfo(this.userid)
      if (res.success != true) return this.$Message.info(res.msg)
      this.avatarsrc = res.rows.headicon
      this.form = res.rows
    },
    handleAvatarSuccess (res, file) {
      this.avatarsrc = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
}
</script>
<style lang='less' scoped>
.basicinfomation {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0px 20px;
  .top {
    width: 100%;
    padding: 10px 20px 0 20px;
    border-bottom: 1px solid #ccc;
    height: 40px;
    font-size: 15px;
    font-weight: 600;
  }
  .body {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    /deep/.avatar {
      margin-right: 80px;
      width: 200px;
      height: 200px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .userInfo {
      width: 500px;
      /deep/.el-input__inner {
        color: #000;
      }
    }
  }
}
</style>